import { render, staticRenderFns } from "./BlockPerson.vue?vue&type=template&id=4ea6038c"
import script from "./BlockPerson.vue?vue&type=script&lang=js"
export * from "./BlockPerson.vue?vue&type=script&lang=js"
import style0 from "./BlockPerson.vue?vue&type=style&index=0&id=4ea6038c&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports